import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { AuthProvider } from './services/auth'
import { ThemeProvider } from './theme'
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext'
import { apolloClient } from './graphql/client'
import App from './App.tsx'
import './index.css'

// Add worktree ID to page title for dev environment identification
const worktreeId = import.meta.env.VITE_WORKTREE_ID
if (worktreeId) {
  document.title = `[WT${worktreeId}] ${document.title}`
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="auto">
      <FeatureFlagsProvider>
        <BrowserRouter>
          <ApolloProvider client={apolloClient}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ApolloProvider>
        </BrowserRouter>
      </FeatureFlagsProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
